/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth__Referral_CodeInputs */

const en_auth__referral_code = /** @type {(inputs: Auth__Referral_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral code, if any`)
};

/**
* | output |
* | --- |
* | "Referral code, if any" |
*
* @param {Auth__Referral_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth__referral_code = /** @type {((inputs?: Auth__Referral_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth__Referral_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth__referral_code(inputs)
});